export type MagentoStoreConfig = {
  store_code: string;
  store_group_code: string;
  website_code: string;
  is_order_limit_enabled: boolean;
  is_age_verification_enabled: boolean;
  age_verification_mode: "CART" | "DISABLED" | "SHIPPING";
  is_free_gifts_enabled: boolean;
  gift_basket_quantity_limitation: string;
  order_limit_value: number;
  base_currency_code: string;
  postcode_validation_enabled: boolean;
  postcode_is_required: boolean;
  postcode_max_length: number;
  postcode_min_length: number;
  postcode_validate_regex: string;
  allow_empty_firstname: boolean;
  cartons_limit_value?: number;
};
